import classNames from 'classnames';

import { isSemrush } from '/src/utils/semrush';

export function CreatedByText({ name = null, textOnly = false, className }) {
  if (!name) return null;
  if (isSemrush) return null;

  if (textOnly) return ` by ${name}`;

  return (
    <div className={classNames('text-caption w-full min-w-0 truncate', className)}>
      <span className="truncate">by {name}</span>
    </div>
  );
}
